import { connect } from 'react-redux';
import { getLatestIterationSelector } from 'state/selectors/iterations-picker';
import { getPullRequestsSingle } from 'state/callers';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { contributorsByIdSelector } from 'state/selectors/contributors';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';
import { myAccountSelector } from 'state/selectors/account';
import PullRequests from './PullRequests';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => {
  const { prs, repositories, currentTeams } = state;

  return {
    contributorsById: contributorsByIdSelector(state),
    currentTeams,
    prs,
    repositories,
    latestIteration: getLatestIterationSelector(state),
    selectedTeam: selectedTeamSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    myAccount: myAccountSelector(state),
    license: licenseSelector(state)
  };
};

const mapDispatchToProps = {
  getPullRequestsSingle
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(PullRequests, 'Pull Requests'));
